import { render, staticRenderFns } from "./WallSponsorsBlockSettings.vue?vue&type=template&id=5e706e72"
import script from "./WallSponsorsBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallSponsorsBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports